module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_42.b2640a98.jpg";